export class RemoteCursorPointEvent {
    constructor(
        public IsHold: boolean,
        public XMousePos: number,
        public YMousePos: number
    ) { }
}